import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  {
    q: "How much does a website cost?",
    a: "Pricing depends on scope, but most business websites start at ₹15,000 and go up based on pages, features, integrations and e-commerce needs. You'll receive a clear, fixed quote after the free consultation.",
  },
  {
    q: "How long does it take?",
    a: "A typical 4–6 page business website is delivered in 7–14 days. Landing pages can ship in 3–5 days. E-commerce and custom builds take 3–6 weeks.",
  },
  {
    q: "Will it work on mobile devices?",
    a: "Yes. Every site I build is mobile-first and tested across phones, tablets and desktops. 60%+ of your traffic is on mobile — your site will feel premium there.",
  },
  {
    q: "Can I update it later?",
    a: "Absolutely. You'll either get a simple admin panel to update content yourself, or affordable maintenance plans where I update it for you within hours.",
  },
  {
    q: "Do you provide support?",
    a: "Yes — every project includes 30 days of free post-launch support, and optional monthly maintenance plans for ongoing updates, security and growth.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 sm:py-32 border-t border-white/5 bg-[#050505]"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-8">
        <div className="max-w-2xl mb-12">
          <div className="text-[11px] tracking-[0.2em] uppercase text-[#D4AF37] mb-4">
            Common Questions
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-light text-white">
            Frequently asked <span className="gold-text italic">questions.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <motion.div
              key={f.q}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.55, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] }}
            >
              <AccordionItem
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/10 last:border-b-0"
              >
                <AccordionTrigger className="text-left text-white hover:text-[#D4AF37] hover:no-underline py-6 font-display text-lg sm:text-xl transition-colors">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#B0B0B0] leading-relaxed pb-6 text-base">
                  <motion.div
                    initial={{ opacity: 0, y: -6 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.35, delay: 0.05 }}
                  >
                    {f.a}
                  </motion.div>
                </AccordionContent>
              </AccordionItem>
            </motion.div>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
